import { getCookie } from "./Utilities";
import axios from "axios";
import { FreeTrial } from "./FreeTrial";
import { BLACKLISTED_USERNAMES } from "../aws/authentication/UserAuth";
// noinspection JSUnusedGlobalSymbols
export const CREATIVE_TYPES = [{
  label: 'Crafty & Fun',
  value: 'crafty'
}, {
  label: 'Bold & Graphic',
  value: 'bold'
}, {
  label: 'Simple & Elegant',
  value: 'simple'
}, {
  label: 'Business & Professional',
  value: 'pro'
}, {
  label: 'Other',
  value: 'all'
}];
const DEFAULT_AVATAR = 'default';

// role constants
export const ROLE_ADMIN = 'admin';
export const ROLE_BETA_PREMIUM = 'beta-premium';
export const ROLE_CUSTOMER = 'customer';
export const ROLE_DEVELOPER = 'developer';
export const ROLE_PROMO_PARTNER = 'promo-partner'; // role that allows some visibility into system data for companies that run machine promos
export const ROLE_SUPPORT = 'support';
export const ROLE_TRANSLATOR = 'translator';
// noinspection JSUnusedGlobalSymbols
export const ALL_ROLES = [ROLE_ADMIN, ROLE_BETA_PREMIUM, ROLE_CUSTOMER, ROLE_DEVELOPER, ROLE_PROMO_PARTNER, ROLE_SUPPORT, ROLE_TRANSLATOR];
export const EMPLOYEE_ROLES = [ROLE_ADMIN, ROLE_DEVELOPER, ROLE_SUPPORT];
export const FREE_TRIAL_STATUS_ACTIVE = 'active';
export const FREE_TRIAL_STATUS_EXPIRED = 'expired';
// noinspection JSUnusedGlobalSymbols
export const FREE_TRIAL_STATUS_PENDING = 'pending';

// noinspection JSUnusedGlobalSymbols
export const SUBSCRIPTION_STATUS_ACTIVE = 'active';
// noinspection JSUnusedGlobalSymbols
export const SUBSCRIPTION_STATUS_INACTIVE = 'stopped';
export const LANGUAGE_COOKIE = 'languageCode';
const META_DATA_CACHE_KEY = 'user-meta-data';
export const META_DATA_FREE_TRIAL_KEY = 'lds-free-trial';

// MFA constants
export const MFA_TYPE_NO_MFA = 'NOMFA';
export const MFA_TYPE_SMS = 'SMS_MFA';
export const MFA_TYPE_SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';
export const MFA_TYPE_TOTP = 'TOTP';
// noinspection JSUnusedGlobalSymbols
export const SMS_SUPPORTED_COUNTRIES = ['CA', 'US'];
export function addFreeTrialDataToObject(metaData, idToken, sub) {
  // handle free trial logic, if necessary
  if (typeof metaData[META_DATA_FREE_TRIAL_KEY] !== 'undefined') {
    // store the initial state of the object
    const fetchedTrialStatus = metaData[META_DATA_FREE_TRIAL_KEY]['status'];

    // check the timing to set it as active, pending, or expired
    const now = Date.now();
    const endTimeMs = metaData[META_DATA_FREE_TRIAL_KEY]['end'] * 1000;
    if (metaData[META_DATA_FREE_TRIAL_KEY]['status'] === FREE_TRIAL_STATUS_ACTIVE) {
      if (endTimeMs < now) {
        metaData[META_DATA_FREE_TRIAL_KEY]['status'] = FREE_TRIAL_STATUS_EXPIRED;
      }
    }

    // if the status changed, save it for the next page load
    if (metaData[META_DATA_FREE_TRIAL_KEY]['status'] !== fetchedTrialStatus) {
      saveMetaData(metaData, idToken, sub, () => {}, () => {});
    }
  } else {
    metaData[META_DATA_FREE_TRIAL_KEY] = new FreeTrial();
    saveMetaData(metaData, idToken, sub, () => {}, () => {});
  }
}
export async function checkUsernameExists(username) {
  if (BLACKLISTED_USERNAMES.includes(username)) {
    return true;
  }
  try {
    await axios.get(process.env.SISER_API_ENDPOINT + 'user/' + username + '/availability');
    return true;
  } catch (err) {
    return err.response.status !== 404;
  }
}
export function defaultUser() {
  let defaults = getDefaults();
  return {
    avatar: DEFAULT_AVATAR,
    cognitoChecked: false,
    countryCode: defaults.defaultCountryCode,
    dateCreated: '',
    email: '',
    firstName: 'Guest',
    id: '',
    isNewsletterSubscriber: true,
    isPlaceholder: false,
    isPremiumSubscriber: false,
    languageCode: defaults.defaultLangCode,
    lastName: '',
    MFA: MFA_TYPE_NO_MFA,
    phoneNumber: '',
    role: '',
    signedIn: false,
    softwareUserId: '',
    timezone: null,
    type: '',
    username: ''
  };
}

// noinspection JSUnusedGlobalSymbols
export async function emailExists(email) {
  try {
    let response = await axios.get(process.env.SISER_API_ENDPOINT + 'user/email/' + encodeURIComponent(email.trim()), {
      headers: {
        'Cache-Control': 'max-age=0'
      }
    });
    return response.status === 200;
  } catch (err) {
    return false;
  }
}
export function fetchMetaData(idToken, sub, onSuccess, onError, cached, role) {
  // pull from the cached value, if available
  if (typeof window !== 'undefined' && typeof cached === 'undefined' || cached) {
    let metaDataRaw = window.sessionStorage.getItem(META_DATA_CACHE_KEY + '-' + sub);
    if (metaDataRaw) {
      let metaData = JSON.parse(metaDataRaw);
      addFreeTrialDataToObject(metaData, idToken, sub);
      onSuccess(metaData);
      return;
    }
  }
  let headers = {
    "Authorization": idToken,
    'Cache-Control': 'max-age=0'
  };
  if (role && EMPLOYEE_ROLES.includes(role)) {
    headers['x-siser-elevated-roles'] = '1';
  }
  axios.get(process.env.SISER_API_ENDPOINT + 'user/meta-data/?cognito_sub=' + sub, {
    headers: headers
  }).then(response => {
    addFreeTrialDataToObject(response['data'], idToken, sub);
    onSuccess(response['data']);
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem(META_DATA_CACHE_KEY + '-' + sub, JSON.stringify(response['data']));
    }
  }).catch(err => {
    onError(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function fetchUserByUsername(session, username, successCallback, errorCallback, useCache) {
  let headers = {
    "Authorization": session['idToken']['jwtToken']
  };
  if (!useCache) {
    headers['Cache-Control'] = 'max-age=0';
  }
  axios.get(process.env.SISER_API_ENDPOINT + 'user/' + username, {
    "headers": headers
  }).then(response => {
    if (response.status === 200) {
      successCallback(response.data);
    }
  }).catch(e => {
    if (typeof e.response.data['errorMessage'] !== 'undefined') {
      errorCallback(e.response.data['errorMessage']);
    } else {
      errorCallback('An unknown error occurred');
    }
  });
}
export function fetchUserRegistrations(session, user, setRegistrationsCallback, errorCallback, cacheResults) {
  if (typeof FormData !== 'undefined') {
    let requestHeaders = {
      "Authorization": session['idToken']['jwtToken']
    };
    if (typeof cacheResults !== 'undefined' && !cacheResults) {
      requestHeaders['Cache-Control'] = 'max-age=0';
    }
    axios.get(process.env.SISER_API_ENDPOINT + 'user/product-registration/?cognito_sub=' + user.id + '&software_user_id=' + user.softwareUserId, {
      headers: requestHeaders
    }).then(response => {
      if (response.status === 200) {
        // transform the response to the expected format
        for (let i = 0; i < response.data.results.length; i++) {
          response.data.results[i] = formatRegistrationResponses(response.data.results[i]);
        }
        setRegistrationsCallback(response.data.results);
      }
    }).catch(e => {
      console.log(e);
      if (typeof e['message'] !== 'undefined') {
        errorCallback(e.message);
      } else {
        errorCallback('An unknown error occurred');
      }
    });
  }
}

// noinspection JSUnusedGlobalSymbols
export function fetchRegistrationHistory(session, serial_number, setRegistrationsCallback, errorCallback, cacheResults) {
  if (typeof FormData !== 'undefined') {
    let requestHeaders = {
      "Authorization": session['idToken']['jwtToken']
    };
    if (typeof cacheResults !== 'undefined' && !cacheResults) {
      requestHeaders['Cache-Control'] = 'max-age=0';
    }
    axios.get(process.env.SISER_API_ENDPOINT + 'product-registration/' + serial_number + '/history/count', {
      headers: requestHeaders
    }).then(response => {
      if (response.status === 200) {
        setRegistrationsCallback(response.data);
      }
    }).catch(e => {
      console.log(e);
      if (typeof e['message'] !== 'undefined') {
        errorCallback(e.message);
      } else {
        errorCallback('An unknown error occurred');
      }
    });
  }
}
function formatRegistrationResponses(result) {
  return {
    ...result,
    cognitoSub: result.cognito_sub,
    dateCreated: result.date_created,
    dateModified: result.date_modified,
    modelNumber: result.model_number,
    otherPurchaseMethodDescription: result.other_purchase_method_description,
    otherStoreDescription: result.other_store_description,
    purchaseDate: result.purchase_date,
    purchaseMethod: result.purchase_method,
    serialNumber: result.serial_number,
    storeCountry: result.store_country,
    storeName: result.store_name,
    storeState: result.store_state
  };
}
function getDefaults() {
  let defaultCountryCode = 'US';
  let defaultLangCode = 'en';
  let langCookie = getCookie(LANGUAGE_COOKIE);
  if (langCookie && langCookie.length > 0) {
    defaultLangCode = getCookie(LANGUAGE_COOKIE);
  } else if (typeof navigator !== 'undefined') {
    let langParts = navigator.language.split('-');
    if (langParts.length > 1) {
      defaultCountryCode = langParts[1].toUpperCase() ?? 'US';
    }
    defaultLangCode = langParts[0];
  }
  return {
    defaultCountryCode: defaultCountryCode,
    defaultLangCode: defaultLangCode
  };
}
export function getUsernameFromEmail(email) {
  return axios.get(process.env.SISER_API_ENDPOINT + 'user/username?email=' + email);
}

// noinspection JSUnusedGlobalSymbols
export function logSignInSuccess(sub, authenticatedSession, successCallback, errorCallback) {
  axios.post(process.env.SISER_API_ENDPOINT + 'user/sign-in-log', {
    'sub': sub
  }, {
    headers: {
      "Authorization": authenticatedSession['idToken']['jwtToken']
    }
  }).then(data => {
    successCallback(data);
  }).catch(err => {
    errorCallback(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function MFAtoString(user) {
  switch (user.MFA) {
    case MFA_TYPE_NO_MFA:
      return 'None';
    case MFA_TYPE_SMS:
      return 'SMS (Code sent via text message)';
    case MFA_TYPE_SOFTWARE_TOKEN_MFA:
    case MFA_TYPE_TOTP:
      return 'Authenticator app';
    default:
      return user.MFA;
  }
}
export function passwordValid(password) {
  if (typeof password === 'undefined') {
    password = '';
  }
  return password.length > 0 && /\d/.test(password) && /[A-Z]/.test(password) && /[a-z]/.test(password) && password.length >= 10;
}
export function password2Valid(password, password2) {
  if (typeof password === 'undefined') {
    password = '';
  }
  if (typeof password2 === 'undefined') {
    password2 = '';
  }
  return password2.length > 0 && password2 === password;
}

// noinspection JSUnusedGlobalSymbols
export function preloadedUser() {
  let user = defaultUser();
  user.isPlaceholder = true;
  return user;
}
export function sanitizedUsername(username) {
  // @ts-ignore
  return username.replaceAll(/[^a-zA-Z\d-_.@]/ig, '').toLowerCase();
}
export function saveMetaData(metaObj, idToken, sub, onSuccess, onError) {
  axios.post(process.env.SISER_API_ENDPOINT + 'user/meta-data/?cognito_sub=' + sub, metaObj, {
    headers: {
      "Authorization": idToken
    }
  }).then(response => {
    // save to cache, if available
    if (typeof window !== 'undefined') {
      let metaData = {};
      let metaDataRaw = window.sessionStorage.getItem(META_DATA_CACHE_KEY + '-' + sub);
      if (metaDataRaw) {
        metaData = JSON.parse(metaDataRaw);
      }
      for (let key in metaObj) {
        metaData[key] = metaObj[key];
      }
      window.sessionStorage.setItem(META_DATA_CACHE_KEY + '-' + sub, JSON.stringify(metaData));
    }
    onSuccess(response);
  }).catch(err => {
    onError(err);
  });
}
export function saveToDb(session, user, successCallback, errorCallback) {
  const userData = {
    "cognito_sub": user.id,
    "country_code": user.countryCode.toUpperCase(),
    "email": user.email,
    "first_name": user.firstName,
    "is_lds_prem_sub": user.isPremiumSubscriber,
    "language_code": user.languageCode,
    "last_name": user.lastName,
    "newsletter_subscriber": user.isNewsletterSubscriber,
    "phone": user.phoneNumber,
    "timezone": user.timezone ?? 'America/Detroit',
    "username": user.username
  };
  if (typeof session !== 'undefined' && session && typeof session['idToken'] !== 'undefined') {
    axios.post(process.env.SISER_API_ENDPOINT + 'user/', userData, {
      headers: {
        "Authorization": session['idToken']['jwtToken']
      }
    }).then(response => {
      if (response.status === 200) {
        successCallback(response);
      } else {
        errorCallback(response.data['errorMessage'] ?? response.statusText);
      }
    }).catch(e => {
      errorCallback(e.message);
    });
  } else {
    axios.post(process.env.SISER_API_ENDPOINT + 'user/', userData).then(response => {
      if (response.status === 200) {
        successCallback(response);
      } else {
        errorCallback(response.data['errorMessage'] ?? response.statusText);
      }
    }).catch(e => {
      errorCallback(e.message);
    });
  }
}
export function sendSoftwareUserUpdate(session, user) {
  axios.post(process.env.SISER_API_ENDPOINT + 'user/software-user', {
    cognito_sub: user.id,
    software_user_id: user.softwareUserId,
    username: user.username
  }, {
    headers: {
      "Authorization": session['idToken']['jwtToken']
    }
  }).then(() => {}).catch(err => {
    console.log(err);
  });
}

// noinspection JSUnusedGlobalSymbols
export function setUserFromCognitoSession(session, MfaData, setUser, errorCallback) {
  const payload = session['idToken']['payload'];
  let defaults = getDefaults();
  if (typeof payload['custom:country_code'] !== 'undefined' && payload['custom:country_code']) {
    payload['custom:country_code'] = payload['custom:country_code'].toUpperCase();
  }
  let user = defaultUser();
  user.avatar = payload['custom:avatar'] ?? DEFAULT_AVATAR;
  user.cognitoChecked = true;
  user.countryCode = payload['custom:country_code'] ?? defaults.defaultCountryCode;
  user.email = payload['email'];
  user.firstName = payload['given_name'];
  user.id = payload['sub'];
  user.isNewsletterSubscriber = typeof payload['custom:newsletter'] !== 'undefined' ? payload['custom:newsletter'] !== "0" : false;
  user.isPlaceholder = false;
  user.isPremiumSubscriber = typeof payload['custom:is_lds_prem_sub'] !== 'undefined' ? payload['custom:is_lds_prem_sub'] > 0 : false;
  user.languageCode = payload['custom:language_code'] ?? defaults.defaultLangCode;
  user.lastName = payload['family_name'];
  user.MFA = MfaData ?? MFA_TYPE_NO_MFA;
  user.phoneNumber = payload['phone_number'];
  user.role = payload['custom:role'] ?? '';
  user.signedIn = true;
  user.softwareUserId = payload['custom:software_user_id'] ?? '';
  user.timezone = payload['custom:timezone'] ?? null;
  user.type = payload['custom:user_type'] ?? '';
  user.username = payload['cognito:username'];

  // check for owned models in storage
  const OWNED_MODELS_CACHE_KEY = 'siser-user-owned-models-' + user.id;
  if (typeof window !== 'undefined') {
    if (window.sessionStorage.getItem(OWNED_MODELS_CACHE_KEY) !== null) {
      user.ownedModels = JSON.parse(window.sessionStorage.getItem(OWNED_MODELS_CACHE_KEY) ?? '');
    }
    let metaDataRaw = window.sessionStorage.getItem(META_DATA_CACHE_KEY + '-' + user.id);
    if (metaDataRaw) {
      user.metaData = JSON.parse(metaDataRaw);
    }
  }
  setUser(user, session);

  // add owned models
  let tmpUser = JSON.parse(JSON.stringify(user));
  if (typeof tmpUser['ownedModels'] === 'undefined') {
    fetchUserRegistrations(session, tmpUser, registrations => {
      tmpUser.ownedModels = [];
      for (let i = 0; i < registrations.length; i++) {
        if (!tmpUser.ownedModels.includes(registrations[i].model_number)) {
          tmpUser.ownedModels.push(registrations[i].model_number);
        }
      }
      if (typeof window !== 'undefined') {
        window.sessionStorage.setItem(OWNED_MODELS_CACHE_KEY, JSON.stringify(tmpUser.ownedModels));
      }
      if (typeof tmpUser['metaData'] === 'undefined') {
        fetchMetaData(session['idToken']['jwtToken'], tmpUser.id, metaData => {
          tmpUser.metaData = metaData;
          setUser(tmpUser, session);
        }, errorCallback, true);
      } else {
        setUser(tmpUser, session);
      }
    }, errorCallback, false);
  } else {
    if (typeof tmpUser['metaData'] === 'undefined') {
      fetchMetaData(session['idToken']['jwtToken'], tmpUser.id, metaData => {
        tmpUser.metaData = metaData;
        setUser(tmpUser, session);
      }, errorCallback);
    }
  }
}